import {
  filterOptionsWithWindow,
  LIST_WINDOW_SIZE,
  matchesNumericField,
  matchesTextByWordStart,
  normalizeText,
  scoreTextByWordStart,
} from '../selectSearchFilter';

export function matchesEquipamentoQuery(equipamento, query) {
  if (matchesTextByWordStart(equipamento.modelo, query)) {
    return true;
  }

  return (
    matchesNumericField(equipamento.numSerie, query) ||
    matchesNumericField(equipamento.numPatrimonio, query) ||
    matchesNumericField(equipamento.codigoSisant, query)
  );
}

export function scoreEquipamentoMatch(equipamento, query) {
  const textScore = scoreTextByWordStart(equipamento.modelo, query);
  if (textScore) {
    return textScore;
  }

  if (matchesNumericField(equipamento.numSerie, query)) {
    return 1;
  }

  if (matchesNumericField(equipamento.numPatrimonio, query)) {
    return 1;
  }

  if (matchesNumericField(equipamento.codigoSisant, query)) {
    return 1;
  }

  return 0;
}

export function filterEquipamentoOptions(
  options,
  { inputValue },
  { windowSize = LIST_WINDOW_SIZE, loadedCount } = {}
) {
  return filterOptionsWithWindow(options, inputValue, {
    windowSize,
    loadedCount,
    matchFn: (equipamento, q) => matchesEquipamentoQuery(equipamento, q),
    sortFn: (a, b, q) => {
      const scoreDiff = scoreEquipamentoMatch(b, q) - scoreEquipamentoMatch(a, q);
      if (scoreDiff !== 0) {
        return scoreDiff;
      }
      return normalizeText(a.modelo).localeCompare(normalizeText(b.modelo), 'pt-BR');
    },
  });
}
